import React, { PropsWithChildren } from "react";
import CloseIcon from "assets/icons/close.svg?react";
import styles from "./index.module.scss";
import { exists } from "helpers/booleans";
import { BannerButtonProps } from "../types";

export interface BannerProps extends PropsWithChildren {
    header?: string;
    hide?: boolean;
    subheader?: string;
    onClose?: () => void;
    element?: React.ReactNode;
    buttonProps?: BannerButtonProps;
    imgSrc?: string;
}

export const BannerBase: React.FC<BannerProps> = ({
    header,
    subheader,
    hide,
    onClose,
    element,
    buttonProps,
    children,
    imgSrc
}) =>
    !hide && (
        <div className={styles["banner-container"]}>
            <div className={styles["banner"]}>
                {imgSrc && (
                    <img
                        className={styles["banner-img"]}
                        src={imgSrc}
                        alt="Banner Image"
                    ></img>
                )}
                <div>
                    <span>
                        <div className={styles["body"]}>
                            <span className={styles["message"]}>
                                <span className={styles["header-container"]}>
                                    <h4 className={styles["header"]}>
                                        {header}
                                    </h4>
                                    {onClose && (
                                        <button
                                            className={styles["close-btn"]}
                                            onClick={onClose}
                                        >
                                            <CloseIcon />
                                        </button>
                                    )}
                                </span>
                                <span className={styles["subheader-container"]}>
                                    {subheader && (
                                        <small className={styles["subheader"]}>
                                            {subheader}
                                        </small>
                                    )}
                                    {buttonProps && (
                                        <button
                                            className={`btn ${
                                                buttonProps.type
                                            } ${
                                                styles[buttonProps.className] ??
                                                ""
                                            }`}
                                            type="button"
                                            onClick={buttonProps.onClick}
                                        >
                                            {buttonProps.label}
                                        </button>
                                    )}
                                </span>
                            </span>
                        </div>
                    </span>
                    {children}
                </div>
                <span
                    className={`${styles["element-container"]} ${
                        exists(element) ? styles["has-element"] : ""
                    }`}
                >
                    {element}
                </span>
            </div>
        </div>
    );
